import { Anchor, Instagram, Facebook, MapPin, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="bg-navy text-white mt-24"
      data-testid="main-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Anchor size={20} strokeWidth={1.5} />
            <span className="font-serif-display text-2xl">Anchor Management</span>
          </div>
          <p className="text-sm text-white/70 max-w-xs leading-relaxed">
            A privately-chartered 35ft Bavaria sailing experience off the turquoise coast of Bermuda.
          </p>
          <div className="flex items-center gap-4 pt-2">
            <a
              href="https://www.instagram.com/anchormgtbda/"
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 border border-white/30 flex items-center justify-center hover:bg-white hover:text-navy transition-colors"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
            >
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 border border-white/30 flex items-center justify-center hover:bg-white hover:text-navy transition-colors"
              data-testid="footer-facebook-link"
              aria-label="Facebook"
            >
              <Facebook size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-white/60 mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About the Boat</Link></li>
            <li><Link to="/experiences" className="hover:text-white" data-testid="footer-link-experiences">Experiences</Link></li>
            <li><Link to="/events" className="hover:text-white" data-testid="footer-link-events">Events</Link></li>
            <li><Link to="/captains-club" className="hover:text-white" data-testid="footer-link-club">Captain's Club</Link></li>
            <li><Link to="/members/login" className="hover:text-white" data-testid="footer-link-members">Members' Lounge</Link></li>
            <li><Link to="/menu" className="hover:text-white" data-testid="footer-link-menu">Menu</Link></li>
            <li><Link to="/gallery" className="hover:text-white" data-testid="footer-link-gallery">Gallery</Link></li>
            <li><Link to="/policy" className="hover:text-white" data-testid="footer-link-policy">Policy</Link></li>
            <li><Link to="/gift" className="hover:text-white" data-testid="footer-link-gift">Gift a Charter</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-white/60 mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2"><Mail size={14} /> anchormgtbda@gmail.com</li>
            <li className="flex items-center gap-2"><Phone size={14} /> 441-519-1794</li>
            <li className="flex items-center gap-2"><MapPin size={14} /> Bermuda</li>
          </ul>
        </div>

        <div>
          <div className="overline text-white/60 mb-4">Ready to sail?</div>
          <p className="text-sm text-white/70 mb-5 leading-relaxed">
            Choose your date, your sun angle, and your pour. We'll handle the rest.
          </p>
          <Link
            to="/book"
            className="btn-primary bg-white text-navy border-white hover:bg-[color:var(--am-pink)] hover:text-navy"
            data-testid="footer-book-now-button"
          >
            Book Your Charter
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Anchor Management · Bermuda</span>
          <span>Chartered with care. Sailed with soul.</span>
        </div>
      </div>
    </footer>
  );
}
